import React from 'react'
import { Flex, NewCard } from '@fareye/ui'
import {
  DetailsContainer,
  DetailsContainerInfo,
  DetailsTimeline,
  DisplayMapInfo,
  SideBarListing,
  TripTabs
} from '../../style/styled'
import { mapComponent } from '../../utility/constants'
import { ShipmentTimeLine, PackageTimeLine } from '@fareye/intransit'
import { MapDisplay } from './component/MapDisplay'
import { isEmpty } from '@fareye/utils'
import queryString from 'query-string'
import { useTranslation } from '@fareye/common'
import { AiCamera } from './component/AiCamera'

export const ModelLayout = ({
  mapKey,
  defaultBaseLayer,
  data,
  otherData,
  config,
  type,
  moveMarker,
  location,
  aerisLayer,
  onTrackingProviderChange,
  trackingProvider
}: any) => {
  const {
    config: { tabsComponent }
  } = config
  const { stoppages = [] } = otherData
  // const { stoppages = [] } = otherData
  type === 'shipment' &&
    data.transportMode !== 'ocean' &&
    delete tabsComponent.oceanPortLogs
  const tab = type === 'container' ? 'oceanPortLogs' : (queryString.parse(location.search).tab || '');
  const { packageLegs = [], history } = data
  const [sideBarTab, setSideBarTab] = React.useState<any>(tab ? tab : 'summary')
  const [stoppage, setStoppage] = React.useState([])
  const [selectedId, setSelectedId] = React.useState({
    stoppage: 0,
    location: '',
    exception: 0,
    origin: false,
    destination: false,
    stops: 0
  })
  const { t } = useTranslation()

  let routes =
    packageLegs.length > 1
      ? packageLegs.map((leg: any) => {
          return { label: leg.attachRoute, value: leg.attachRoute }
        })
      : []
  routes.unshift({ label: 'All', value: 'all' })
  const [selectedRoute, setSelectedRoute] = React.useState({
    label: 'All',
    value: 'all'
  })
  const [histories, setHistories] = React.useState(history)
  const [historySlider, setHistorySlider] = React.useState(
    history
      ? {
          min: Math.min(
            ...history.map((h: any) => new Date(h.gpsTimestamp).getTime())
          ),
          max: Math.max(
            ...history.map((h: any) => new Date(h.gpsTimestamp).getTime())
          )
        }
      : {}
  )
  const [currHistorySlider, setCurrHistorySlider] = React.useState(
    histories
      ? {
          min: Math.min(
            ...histories.map((h: any) => new Date(h.gpsTimestamp).getTime())
          ),
          max: Math.max(
            ...histories.map((h: any) => new Date(h.gpsTimestamp).getTime())
          )
        }
      : {}
  )
  const [loadsensor, setLoadsensor] = React.useState(history)
  const [aiCamera, setAiCamera] = React.useState(history)
  const [stoppageSlider, setStoppageSlider] = React.useState({})
  const [currStoppageSlider, setCurrStoppageSlider] = React.useState({})

  React.useEffect(() => {
    const h = history || []
    setHistories(h)
    setLoadsensor(h)
    setAiCamera(h)
    if (!isEmpty(h)) {
      const min = Math.min(...h.map((h: any) => new Date(h.gpsTimestamp).getTime()))
      const max = Math.max(...h.map((h: any) => new Date(h.gpsTimestamp).getTime()))
      setHistorySlider({ min, max })
      setCurrHistorySlider({ min, max })
    }
  }, [data])

  React.useEffect(() => {
    !isEmpty(stoppages) && setStoppage(stoppages)
  }, [otherData])

  React.useEffect(() => {
    setSelectedId({
      stoppage: 0,
      location: '',
      exception: 0,
      origin: false,
      destination: false,
      stops: 0
    })
  }, [sideBarTab])

  React.useEffect(() => {
    !isEmpty(stoppages) &&
      setStoppageSlider({
        min: Math.min(...stoppages.map((h: any) => h.duration * 1000)),
        max: Math.max(...stoppages.map((h: any) => h.duration * 1000))
      })
    setCurrStoppageSlider(
      (Math.max(...stoppages.map((h: any) => h.duration * 1000)) +
        Math.min(...stoppages.map((h: any) => h.duration * 1000))) /
        2
    )
  }, [stoppages])
  React.useEffect(() => {
    if (selectedRoute.value == 'all') {
      setHistories(history)
      setHistorySlider(
        history
          ? {
              min: Math.min(
                ...history.map((h: any) => new Date(h.gpsTimestamp).getTime())
              ),
              max: Math.max(
                ...history.map((h: any) => new Date(h.gpsTimestamp).getTime())
              )
            }
          : {}
      )
      setCurrHistorySlider(
        history
          ? {
              min: Math.min(
                ...history.map((h: any) => new Date(h.gpsTimestamp).getTime())
              ),
              max: Math.max(
                ...history.map((h: any) => new Date(h.gpsTimestamp).getTime())
              )
            }
          : {}
      )
    } else {
      const leg = packageLegs.find(
        (item: any) => item.attachRoute === selectedRoute.value
      )
      setHistories(leg.history)
      setHistorySlider(
        leg.history
          ? {
              min: Math.min(
                ...leg.history.map((h: any) =>
                  new Date(h.gpsTimestamp).getTime()
                )
              ),
              max: Math.max(
                ...leg.history.map((h: any) =>
                  new Date(h.gpsTimestamp).getTime()
                )
              )
            }
          : {}
      )
      setCurrHistorySlider(
        leg.history
          ? {
              min: Math.min(
                ...leg.history.map((h: any) =>
                  new Date(h.gpsTimestamp).getTime()
                )
              ),
              max: Math.max(
                ...leg.history.map((h: any) =>
                  new Date(h.gpsTimestamp).getTime()
                )
              )
            }
          : {}
      )
    }
  }, [selectedRoute])

  React.useEffect(() => {
    setHistories(
      history.filter((item: any) => {
        return currHistorySlider &&
          currHistorySlider.min &&
          currHistorySlider.max
          ? new Date(item.gpsTimestamp).getTime() >= currHistorySlider.min &&
              new Date(item.gpsTimestamp).getTime() <= currHistorySlider.max
          : true
      })
    )
  }, [currHistorySlider])
  React.useEffect(() => {
    !isEmpty(stoppages) &&
      setStoppage(
        stoppages.filter((item: any) => {
          return currStoppageSlider
            ? item.duration * 1000 >= (currStoppageSlider as any)
            : true
        })
      )
  }, [currStoppageSlider])

  const Component = (mapComponent as any)[tabsComponent[sideBarTab].component]
  return (
    <NewCard
      style={{
        border: 'none',
        width: '100%',
        padding: '0 15px',
        boxSizing: 'border-box'
      }}
    >
      <NewCard.Header>
        <TripTabs>
          {Object.keys(tabsComponent).map((item: string) => (
            <SideBarListing
              isSelected={sideBarTab === item}
              id={item}
              onClick={() => setSideBarTab(item)}
              key={item}
            >
              {t(tabsComponent[item].label)}
              {false && `(${0})`}
            </SideBarListing>
          ))}
        </TripTabs>
      </NewCard.Header>
      <NewCard.Body>
        <DetailsContainer>
          <DetailsContainerInfo showMap={tabsComponent[sideBarTab].showMap}>
            <Component
              data={data}
              otherData={otherData}
              selectedId={selectedId}
              onSelect={setSelectedId}
              config={config}
              type={type}
              changeTab={setSideBarTab}
              histories={histories}
              stoppages={stoppage}
              loadsensor={loadsensor}
              aiCamera={AiCamera}
              routes={routes}
              selectedRoute={selectedRoute}
              setSelectedRoute={setSelectedRoute}
              historySlider={historySlider}
              currHistorySlider={currHistorySlider}
              setCurrHistorySlider={setCurrHistorySlider}
              stoppageSlider={stoppageSlider}
              currStoppageSlider={currStoppageSlider}
              setCurrStoppageSlider={setCurrStoppageSlider}
              onTrackingProviderChange={onTrackingProviderChange}
              trackingProvider={trackingProvider}
            />
          </DetailsContainerInfo>

          {tabsComponent[sideBarTab].showMap ? (
            <DisplayMapInfo>
              <MapDisplay
                mapKey={mapKey}
                aerisLayer={aerisLayer}
                defaultBaseLayer={defaultBaseLayer}
                data={data}
                histories={histories}
                stoppages={stoppage}
                type={type}
                moveMarker={moveMarker}
                otherData={otherData}
                selectedId={selectedId}
                trackingProvider={trackingProvider}
              />

              {type === 'shipment' && (
                <DetailsTimeline>
                  <ShipmentTimeLine rowData={data} timelineData={data.stops} />
                </DetailsTimeline>
              )}
              {type === 'package' && (
                <DetailsTimeline>
                  <PackageTimeLine rowData={data} timelineData={data.nodes} />
                </DetailsTimeline>
              )}
            </DisplayMapInfo>
          ) : null}
        </DetailsContainer>
      </NewCard.Body>
    </NewCard>
  )
}
